import { TemplateProps } from '~/pages/heineken_template/_private/TemplateProps';
import { weng888_init } from './weng888_init';
import { fr_agents } from '~/pages/heineken_template/_fr/fr_agents';
const templateProps = new TemplateProps();
if (fr_agents.is['weng888@web'])
    weng888_init(templateProps);
export default templateProps.NextPage;
